<div class="container mt-4 mb-5">
  <h4 i18n>Novo Pedido</h4>
  <div *ngFor="let e of errorMsg" class="alert alert-primary" role="alert">
    {{ e }}
  </div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="row">
      <div class="col-lg-8">
        <div class="form-group mb-1">
          <label>{{ SITE.labelCliente }}</label>
          <input
            [(ngModel)]="typingCliente"
            [ngModelOptions]="{ standalone: true }"
            [typeaheadAsync]="true"
            [typeahead]="clientesUsuario"
            typeaheadOptionField="{{ 'nome'}}"
            isAnimated="true"
            (typeaheadOnSelect)="onSelect($event)"
            (typeaheadNoResults)="typeaheadNoResults($event)"
            id="cliente"
            autocomplete="off"
            placeholder="Digite o nome do cliente"
            i18n-placeholder="Client name"
            class="form-control"
          />
          <!-- <input
            (input)="onInput($event)"
            placeholder="Digite o nome do cliente"
            class="form-control"
          />
          <div *ngIf="this.term.length > 0" class='select-cliente'>
            <div *ngFor="let c of listClient">
              <button class='btn-cliente-select'>
                <div>asd</div>
              </button>
            </div>
          </div>  -->
        </div>
        <div *ngIf="noResult" class="alert alert-info" i18n>
          Nenhum registro encontrado!
        </div>
        <div
          *ngIf="!selectedCliente"
          class="card card-block card-header p-0 mb-3"
        >
          <div class="alert m-3" i18n>Selecione um ou mais!</div>
        </div>
        <div
          *ngIf="selectedCliente"
          class="card card-block card-header p-0 mb-2"
        >
          <div *ngIf="errorClienteTabela" class="alert alert-danger mb-2" i18n>
            Clientes com tabela de preço diferente!
          </div>
          <div
            *ngIf="errorClienteBloqueado"
            class="alert alert-danger mb-2"
            i18n
          >
            Cliente com pendência financeira
          </div>
          <div class="row pt-2">
            <div class="col-lg-4">
              <div class="form-group mb-1">
                <label i18n>Código</label><br />
                <b>{{ selectedCliente.codigo }}</b>
              </div>
              <div class="form-group mb-1" *ngIf="selectedCliente.limite_credito !==null">
                <label i18n>limite de crédito</label><br />
                <b *ngIf="selectedCliente.limite_credito !== null">R$ {{ selectedCliente.limite_credito | currency : "BRL" : "" }}</b>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="form-group mb-1">
                <label i18n>Nome</label><br />
                {{ selectedCliente.nome }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="form-group">
                <label>{{ selectedCliente.tipodocumento }}</label
                ><br />
                {{ selectedCliente.numdocumento }}
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label i18n>Fantasia</label><br />
                {{ selectedCliente.fantasia }}
              </div>
            </div>
            <div *ngIf="selectedCliente.cidades" class="col-lg-4">
              <div class="form-group" [style.color]="selectedCliente.cidades.nome === null ? 'red':''" >
                <label i18n>Cidade</label><br />
                {{ selectedCliente.cidades.nome}} -
                {{ selectedCliente.cidades.uf}}
              </div>
            </div>
          </div>
          <div
            *ngIf="selectedCliente.enderecos.length > 0; else enderecoElseBlock"
            class="row"
          >
            <table class="table table-hover table-condensed mb-0">
              <thead>
                <tr>
                  <th colspan="2" i18n>Selecione um endereço</th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr>
                  <td style="width: 40px">
                    <input
                      type="radio"
                      value="{{ selectedCliente.enderecos.id}}"
                      [(ngModel)]="clienteIdErp[selectedCliente.id]"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </td>
                  <td>
                    <h6>
                      {{ selectedCliente.enderecos[0].endereco }}
                      {{ selectedCliente.numero }}
                    </h6>
                    {{ selectedCliente.enderecos[0].uf }} -
                    {{ selectedCliente.enderecos[0].descricao }} ({{
                      selectedCliente.cep
                    }}), {{ selectedCliente.enderecos[0].bairro }}
                  </td> 
                </tr> -->
                <tr *ngFor="let a of selectedCliente.enderecos; index as i"
                (click)="select(a.id)">
                  <td style="width: 40px">
                    <!-- <input
                      type="radio"
                      value="{{ a.id }}"
                      [(ngModel)]="clienteIdErp[selectedCliente.id]"
                      [ngModelOptions]="{ standalone: selectedCliente.enderecos.length !== 1 }"
                      [checked]="selectedCliente.enderecos.length === 1"
                    /> -->
                    <div
                    class="mt-1 {{ clienteIdErp[selectedCliente.id] == a.id ? 'selected-radio' : 'unselected-radio'}}">
                    <div *ngIf=" clienteIdErp[selectedCliente.id] == a.id" class="selected-radio-inside">
                    </div>
                  </div>
                  </td>
                  <td>
                    <h6 i18n>{{ a.endereco }} {{ a.numero }}</h6>
                    {{ a.uf }} - {{ a.descricao }} ({{ a.cep }}),
                    {{ a.bairro }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #enderecoElseBlock>
            <table
              *ngIf="selectedCliente.enderecos"
              class="table table-hover table-condensed mb-0"
            >
              <thead>
                <tr>
                  <th colspan="2" i18n>Selecione um endereço</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 40px">
                    <input
                      type="radio"
                      value="{{ selectedCliente.idEnderecoErp }}"
                      [(ngModel)]="clienteIdErp[selectedCliente.id]"
                      [ngModelOptions]="{ standalone: true }"
                      [checked]="selectedCliente.enderecos.length === 1"
                      [defaultChecked]="selectedCliente.enderecos.length === 1"
                    />
                  </td>
                  <td>
                    <h6>
                      {{ selectedCliente.endereco }}
                      {{ selectedCliente.numero }}
                    </h6>
                    {{ selectedCliente.uf }} -
                    {{ selectedCliente.descricao }} ({{
                      selectedCliente.cep
                    }}), {{ selectedCliente.bairro }}
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-template>
        </div>
        <div id="clientes" *ngIf="listCliente.length" class="mb-3">
          <span
            *ngFor="let c of listCliente"
            class="badge badge-primary"
            tooltip="{{ c['cliente' + SITE.identificacaoCliente] }}"
            placement="bottom"
          >
            <span (click)="selecionaCliente(c)" class="descr">{{
              c[SITE.identificacaoCliente]
            }}</span>
            <span class="badge badge-light" (click)="excluiCliente(c)">X</span>
          </span>
        </div>
      </div>
      <div class="col-lg-4">
        <div *ngIf="filiais.length > 1" class="form-group">
          <label>{{ SITE.labelFilial }}</label>
          <select
            id="filial"
            formControlName="filial"
            class="form-control"
            (change)="selecionaFilial($event.target.value)"
          >
            <option value=""></option>
            <option *ngFor="let f of filiais" value="{{ f.id }}">
              {{ f.codigo }} - {{ f.descricao }}
            </option>
          </select>
          <div *ngIf="error && form.get('filial').invalid" class="error" i18n>
            Verifique este campo!
          </div>
        </div>
        <div *ngIf="tabelas.length > 1" class="form-group">
          <label>{{ SITE.labelTabela }}</label>
          <select id="tabela" formControlName="tabela" class="form-control">
            <option value=""></option>
            <option *ngFor="let t of tabelas" value="{{ t.id }}">
              {{ t.codigo }} - {{ t.descricao }}
            </option>
          </select>
          <div *ngIf="error && form.get('tabela').invalid" class="error" i18n>
            Verifique este campo!
          </div>
        </div>
        <div *ngIf="pedidoTiposUsuario.length > 1" class="form-group">
          <label>{{ SITE.labelPedidoTipo }}</label>
          <select
            id="pedidoTipo"
            formControlName="pedidoTipo"
            class="form-control"
            (change)="selectTipo($event)"
            [(ngModel)]="tipoSelecionado"
          >
          <option value="0"></option>
            <option *ngFor="let t of pedidoTiposUsuario" value="{{ t.id }}">
              {{ t.tipo }} - {{ t.descricao }}
            </option>
          </select>
          <div
            *ngIf="error && form.get('pedidoTipo').invalid"
            class="error"
            i18n
          >
            Verifique este campo!
          </div>
        </div>
        <div *ngIf="filial_Estoque.length > 1" class="form-group">
          <label>Filial de estoque</label>
          <select
            id="filialEstoque"
            formControlName="filialEstoque"
            class="form-control"
          >
            <option *ngFor="let t of filial_Estoque" value="{{ t.id }}">
              {{ t.codigo }} - {{ t.descricao }}
            </option>
          </select>
          <div
            *ngIf="error && form.get('filialEstoque').invalid"
            class="error"
            i18n
          >
            Verifique este campo!
          </div>
        </div>
        <div *ngIf="SITE.mostraDataEntrega" class="form-group">
          <label>Data de Entrega</label>
          <input
            type="text"
            class="form-control"
            bsDatepicker
            formControlName="dataEntrega"
            [minDate]="dataEntregaMinDate"
            [daysDisabled]="dataEntregaDaysDisable"
            [bsConfig]="{
              isAnimated: true,
              dateInputFormat: 'DD/MM/YYYY',
              adaptivePosition: true
            }"
          />
          <div
            *ngIf="error && form.get('dataEntrega').invalid"
            class="error"
            i18n
          >
            Verifique este campo!
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <button class="btn btn-primary btn-lg" i18n>Abrir Pedido</button>
      </div>
    </div>
  </form>
</div>
